import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, 
         faUser,
         faSearch,
         faCheck,
         faHeart,
         faChevronDown,
         faChevronUp,
         faPlus,
         faMinus,
         faKey,
         faParking,
         faTrophy,
         faWifi,
         faTv,
         faElevator,
         faKitchenSet,
         faAirFreshener,
         faCar,
         faStar,
         faShield,
         faGlobe,
         faTimes,
         faCamera,
         faGraduationCap,
         faClock,
         faLanguage,
         faLocation,
         faWindowClose,
         faSmile,
         faMessage,
         faCross,
         faBackward,
         faArrowLeft,
         faShoppingBag,
         faDog,
         faMapMarker,
         faMapMarkerAlt,
         faHome,
         faBarChart,
         faHotel,
         faPowerOff,
         faMoneyBill,
         faMoneyCheck,



 } from '@fortawesome/free-solid-svg-icons'


library.add(faBars,
            faUser,
            faSearch,
            faCheck,
            faHeart,
            faChevronDown,
            faChevronUp,
            faPlus,
            faMinus,
            faKey,
            faParking,
            faTrophy,
            faWifi,
            faTv,
            faElevator,
            faKitchenSet,
            faAirFreshener,
            faCar,
            faStar,
            faShield,
            faGlobe,
            faTimes,
            faCheck,
            faCamera,
            faGraduationCap,
            faClock,
            faLanguage,
            faLocation,
            faWindowClose,
            faSmile,
            faMessage,
            faCross,
            faBackward,
            faArrowLeft,
            faShoppingBag,
            faDog,
            faMapMarker,
            faMapMarkerAlt,
            faHome,
            faBarChart,
            faHotel,
            faPowerOff,
            faMoneyBill,
            faMoneyCheck
            
           

            
)